(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxWorkstationRemoveAdapter(
    $http, toastr, $filter
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/workstationProperties/workstationSettings/workstationRemoveAdapter/workstationRemoveAdapter.template.html',
      link: function(scope) {

        scope.removeAdapter = {
          confirmed: false
        }


        scope.confirmAdapterRemoval = function () {
          var url = scope.context.workstation.info._links['px:virtualApaptersRemove'].href;

          var adapter = [];
          adapter.push(scope.context.adapter._links.self.href)

          $http.post(url, adapter).then(function(response) {
            toastr.success($filter('translate')('VirtualAdapterRemoved'));
          }).catch(function(error){
            toastr.error($filter('translate')('ERROR'));
          });
          scope.callback();
        } 

      }
    };
  }

  pxWorkstationRemoveAdapter.$inject = ['$http', 'toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxWorkstationRemoveAdapter', pxWorkstationRemoveAdapter);

})();
